import React, { useEffect } from 'react';

import { useHistory, useParams } from "react-router-dom";

import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import { getGoogleMapsLink } from '../common';

function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

const useStyles = makeStyles(theme => ({
    paper: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(3),
    },
    table: {
        minWidth: 650,
        '& td:nth-child(2), & th:nth-child(2)': {
            minWidth: 160
        }
    },
    tableHeader: {
        backgroundColor: theme.palette.primary.main,
        '& .MuiTableCell-head': {
            color: theme.palette.primary.contrastText,
        },
    },
    disabled: {
        color: '#c7c7c7',
    },
    officiantEventDetails: {
        '& ul': {
            paddingLeft: 25,
            '& li': {
                marginBottom: 4,
                '& p': {
                    fontSize: '0.74rem',
                    textAlign: 'left',
                    lineHeight: '0.9rem',
                }
            }
        }
    },
    userAlert: {
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: '#178cca',
        borderRadius: 4,
        padding: '3px 12px',
        minWidth: 230,
        maxWidth: '100%',
        textAlign: 'center',
        color: '#178cca',
        display: 'inline-block',
        '& span': {
            verticalAlign: 'middle',
        }
    },
    userAlertIcon: {
        paddingRight: 10,
    }
}));

const OfficiantsTable = props => {
    const { wedding, officiants } = props.data;

    const officiantId = wedding.officiant && wedding.officiant.id ? wedding.officiant.id : null;

    const classes = useStyles();

    const rows = officiants;

    const assign = id => event => {
        event.preventDefault();
        if (id == null || id == undefined) {
            alert('An error occured. Please refresh the page and try again.');
            return;
        }
        const data = { _token: window._token, officiant_id: id };
        new Promise((resolve, reject) => {
            const url = `/api/couples/assign-officiant/${wedding.id}`
            resolve();
            fetch(url, {
                method: 'POST',
                body: JSON.stringify(data),
                headers: { 'Content-Type': 'application/json' }
            })
                .then(response => {
                    return response.json();
                })
                .then(result => {
                    window.location = `/admin/leads/officiants/${wedding.id}?assigned=1`;
                })
                .catch(reason => {
                    alert('An error prevented assigning the officiant. Please refresh the page and try again.');
                })
        });
    }

    const unassign = id => event => {
        event.preventDefault();
        if (id == null || id == undefined) {
            alert('An error occured. Please refresh the page and try again.');
            return;
        }
        const data = { _token: window._token, officiant_id: id };
        new Promise((resolve, reject) => {
            const url = `/api/couples/unassign-officiant/${wedding.id}`
            resolve();
            fetch(url, {
                method: 'POST',
                body: JSON.stringify(data),
                headers: { 'Content-Type': 'application/json' }
            })
                .then(response => {
                    return response.json();
                })
                .then(result => {
                    window.location = `/admin/leads/officiants/${wedding.id}?unassigned=1`;
                })
                .catch(reason => {
                    alert('An error prevented unassigning the officiant. Please refresh the page and try again.');
                })
        });
    }

    return (
        <TableContainer component={Paper} variant="outlined" square>
            <Table className={classes.table} aria-label="simple table">
                <TableHead className={classes.tableHeader}>
                    <TableRow>
                        <TableCell align="center">Assign</TableCell>
                        <TableCell align="center">Photo</TableCell>
                        <TableCell align="left">Info</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                {rows.map(row => {
                    const isAlreadyAssigned = officiantId && row.id === officiantId;

                    return (
                        <TableRow key={row.name}>
                            <TableCell align="center">
                                {isAlreadyAssigned && (
                                    <React.Fragment>
                                        <b>Assigned</b><br />
                                        <Link href="#" onClick={unassign(row.id)}>Unassign</Link>
                                    </React.Fragment>
                                )}
                                {!isAlreadyAssigned && <Link href="#" onClick={assign(row.id)}>Assign</Link>}
                            </TableCell>
                            <TableCell align="center">
                                <img src={row.profile_picture_path} style={{width: 180}} />
                                {row.other_weddings && row.other_weddings.length > 0 && (
                                    <Box mt={2} className={classes.officiantEventDetails}>
                                        <Typography>Other Weddings</Typography>
                                        <ul>
                                            {row.other_weddings.map((item, key) => (
                                                <li key={key}>
                                                    <Typography>
                                                        {item.wedding_date_formatted} {item.wedding_time_formatted} ({item.time_zone_short}) <b>{item.couple_type}</b>
                                                        <br />
                                                        <a href={`/admin/couples/${item.id}`} target="_blank">{item.bride_first_name} and {item.groom_first_name}</a>
                                                        {item.venue !== null && item.venue !== '' && (
                                                            <span>
                                                                <br />at {item.venue}
                                                                <br />{item.location && (
                                                                    <a href={getGoogleMapsLink(item.location)} target="_blank">{item.location}</a>
                                                                )}
                                                            </span>
                                                        )}
                                                    </Typography>
                                                </li>
                                            ))}
                                        </ul>
                                    </Box>
                                )}
                                {row.other_events && row.other_events.length > 0 && (
                                    <Box mt={2} className={classes.officiantEventDetails}>
                                        <Typography>Events</Typography>
                                        <ul>
                                            {row.other_events.map(item => (
                                                <li key={`event-${item.id}`}>
                                                    <Typography><a href={`/admin/officiants/events/${item.id}`} target="_blank">{item.title}</a> ({item.start_str} to {item.end_str})</Typography>
                                                </li>
                                            ))}
                                        </ul>
                                    </Box>
                                )}
                                {row.unavailabilities && row.unavailabilities.length > 0 && (
                                    <Box mt={2} className={classes.officiantEventDetails}>
                                        <Typography>Unavailable</Typography>
                                        <ul>
                                            {row.unavailabilities.map(item => (
                                                <li key={`unavailability-${item.id}`}>
                                                    <Typography>{item.note || 'Unavailable'} ({item.start_str} to {item.end_str})</Typography>
                                                </li>
                                            ))}
                                        </ul>
                                    </Box>
                                )}
                            </TableCell>
                            <TableCell align="left">
                                <h3>{row.name}</h3>
                                <div dangerouslySetInnerHTML={{__html: row.officiant_bio}} />
                            </TableCell>
                        </TableRow>
                    )
                })}
                </TableBody>
            </Table>
        </TableContainer>
    )
}


const LeadChooseOfficiant = () => {
    const { id } = useParams();
    const classes = useStyles();

    const [data, setData] = React.useState(null);
    const [loading, setLoading] = React.useState(true);

    const history = useHistory();
    function handleBackClick() {
        history.push('/admin/leads');
    }

    useEffect(() => {
        document.title = 'Choose Officiant - Enduring Promises';
        new Promise((resolve, reject) => {
            let url = `/api/couples/assign-officiant/${id}`
            fetch(url)
                .then(response => {
                    return response.json();
                })
                .then(result => {
                    setData(result);
                    resolve();
                })
                .finally(() => {
                    setLoading(false);
                });
        });
    }, [id]);

    const setAsFollowUp = () => {
        new Promise((resolve) => {
            resolve();
            fetch(`/api/couples/set-as-follow-up/${id}`, {
                method: 'POST',
                body: JSON.stringify({
                    _token: window._token
                }),
                headers: { 'Content-Type': 'application/json' }
            })
            .then(response => {
                return response.json();
            })
            .then(result => {
                const newData = {
                    ...data
                };
                newData.wedding.couple_type = result.couple_type;
                setData(newData);
            });
        });
    }

    return (
        <div>
            <Box mb={2}>
                <Grid
                    container
                    direction="row"
                    justify="space-between"
                    alignItems="center"
                >
                    <Grid item xs={12} sm={4}>
                        <Button startIcon={<Icon>chevron_left</Icon>} onClick={handleBackClick} size="small" variant="outlined" color="primary">Back</Button>
                    </Grid>
                    <Grid item xs={6} sm={4} align="center">
                        {getUrlParameter('assigned') === '1' && (
                            <Typography>
                                <span className={classes.userAlert}>
                                    <span className={classes.userAlertIcon}><CheckCircleOutlineIcon /></span>
                                    <span>Assigned officiant</span>
                                </span>
                            </Typography>
                        )}
                        {getUrlParameter('unassigned') === '1' && (
                            <Typography>
                                <span className={classes.userAlert}>
                                    <span className={classes.userAlertIcon}><CheckCircleOutlineIcon /></span>
                                    <span>Unassigned officiant</span>
                                </span>
                            </Typography>
                        )}
                    </Grid>
                    <Grid item xs={6} sm={4} align="right">
                        {!loading && data !== null && (
                            <React.Fragment>
                                {data.wedding.couple_type === 'Follow-Up' && (
                                    <Button startIcon={<CheckCircleOutlineIcon />} size="small" variant="outlined" color="primary" disabled>
                                        Set Couple as Follow-Up
                                    </Button>
                                )}
                                {data.wedding.couple_type !== 'Follow-Up' && (
                                    <Button onClick={setAsFollowUp} size="small" variant="outlined" color="primary">
                                        Set Couple as Follow-Up
                                    </Button>
                                )}
                            </React.Fragment>
                        )}
                    </Grid>
                </Grid>
            </Box>
            <Paper square className={classes.paper}>
                {loading && (
                    <Grid container direction="row" justify="center" alignItems="center">
                        <Grid item>
                            <CircularProgress color="primary" />
                        </Grid>
                    </Grid>
                )}
                {!loading && data !== null && (
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Typography>Assign Officiant for {data.wedding.bride_first_name} and {data.wedding.groom_first_name}</Typography>
                        </Grid>
                        <Grid item xs={12} className="MuiTypography-alignCenter">
                            <Typography variant="h6">WEDDING</Typography>
                            <Typography variant="h6">{data.wedding.wedding_date_formatted} {data.wedding.wedding_time_formatted} ({data.wedding.time_zone_short})</Typography>
                            <Typography variant="h6">{data.wedding.venue}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <OfficiantsTable data={data} />
                        </Grid>
                    </Grid>
                )}
            </Paper>
        </div>
    );
}

export default LeadChooseOfficiant;
